import React, { useEffect, useState } from "react";
import Label from "../../../CommonComponents/Label";
import close from "client/assets/images/Close_SuccessPopup.svg";
import "./dragDrop.scss";
import { EventHandler, OutlineButton } from "client/CommonComponents";
import { Spinner } from "@softura/fluentuipackage";
import { getFileName } from "utils";


interface IProps {
  multiple?: boolean;
  accept?: string;
  uploadBtnLoading?: boolean;
  uploadBtnClick: Function;
  error?: string;
  onRemove: Function;
  uploadedList: Array<File>;
  reasonattchment?: any;
  disabled?: boolean;
}
const DEFAULT_ACCEPT = ".xlsx,.xls,.doc,.docx,.ppt,.pptx,.pdf,.jpeg,.jpg,.png";

const DragDrop = ({
  multiple = false,
  accept = DEFAULT_ACCEPT,
  uploadBtnClick,
  uploadBtnLoading = false,
  error,
  onRemove,
  uploadedList,
  reasonattchment,
  disabled = false,
}: IProps) => {
  const [list, setList] = useState<Array<File>>([]);
  const [fileError, setFileError] = useState<string>("");
  const [filecheckError, setFilecheckError] = useState<string>("");

  const isValidFormat = (file: File) => {
    const extension = file.name.split(".").at(-1) || "";

    return accept.split(",").includes(`.${extension.toLowerCase()}`);
  };
  const ValidateFile = (file: File) => {
    const fileSize = Math.round((file.size / 1024));
    if (!isValidFormat(file)) {
      setFileError("Please upload a valid file format");
      return false;
    } else if (fileSize >= 5000) {
      setFileError("File size should not exceed 5MB ");
      return false;
    } else {
      setFileError("");
      return true;

    }
  }

  useEffect(() => {
    const filter_Data = [...list.filter((x) => !isUploaded(x.name || (x as any).fileName))]
    if (filter_Data.length == 0) {
      setList(uploadedList)
    }

  }, [error])

  useEffect(() => {
    setList(uploadedList);
  }, []);

  const setListExt = (file: File) => {
    if (isValidFormat(file)) {
      if (multiple) {
        setList((prev) => [...prev, file]);
      } else {
        setList([file]);
      }
    }
  };

  const isUploaded = (name: string) =>
    list.find((x: any) => getFileName(x.attachmentUrl) === name);

  const checkFileList = (list: any, removeFile: string) => {
    
    let isAvaliblefilename;
    for(let i = 0; i < list?.length; i++){
      if (list[i]?.attachments?.length > 0) {
        for(let j = 0; j < list[i]?.attachments?.length; j++){
          if(list[i]?.attachments[j]?.fileName === removeFile){
           
            isAvaliblefilename = true;
            return(isAvaliblefilename) 
          }
          else{
           
            isAvaliblefilename = false;
          }
        }
      }
    }
    return isAvaliblefilename;
  }

  const onRemoveExt = (index: number, name: string) => {
    let checkIsReasonFile = false;
    if (reasonattchment.length > 0) {
      let isAvalibleFile = checkFileList(reasonattchment, name);
      if (isAvalibleFile) {
        checkIsReasonFile = true;
      }
    }
    if (checkIsReasonFile) {
      setFilecheckError("The attachment file cannot be deleted. File linked to the item.");
      return false;
    } else if (!checkIsReasonFile) {
      const newFileList = [...list];
      newFileList.splice(index, 1);
      setList(newFileList);
      onRemove(index);
      setFilecheckError("");
      return true;
    }
  };

  const handleDrop = (ev: React.DragEvent<HTMLInputElement>) => {
    ev.preventDefault();

    if (ev.dataTransfer.items) {
      [...ev.dataTransfer.items]
        .filter((item) => item.kind === "file")
        .forEach((item) => {
          const file = item.getAsFile();
          if (file) {
            setListExt(file);
          }
        });
    } else {
      [...ev.dataTransfer.files].forEach(setListExt);
    }
  };

  const onFileUpload = ({
    target: { files },
  }: React.ChangeEvent<HTMLInputElement>) => {
    if (files?.length) {
      const validFiles = [...files].filter((file: File) => ValidateFile(file));
      if (validFiles.length) {
        if (multiple) {
          setList((prev) => [...prev, ...validFiles]);
        } else {
          setList([validFiles[0]]);
        }
      }
    }
  };

  const onUpload = (event: any) => {
    event.stopPropagation();
    event.preventDefault();

    uploadBtnClick(list);
  };

  const onDragOver = (event: React.DragEvent<HTMLInputElement>) => {
    event.stopPropagation();
    event.preventDefault();
    if (event.dataTransfer) event.dataTransfer.dropEffect = "copy";
  };

  return (
    <div className="dragDrop">
      <div className="dropzone" onDrop={handleDrop} onDragOver={onDragOver}>
        <div className="draggable-container">
          <div className="sub-header">Drag & Drop (or) Browse</div>
          <input
            type="file"
            className="file-browser-input"
            name="file-browser-input"
            multiple={multiple}
            onChange={onFileUpload}
            accept={accept}
           data-attribute="DragDrop_file_browser_input_Input" />
        </div>
        <OutlineButton
          id="uploadBtn"
          onClick={onUpload}
          disabled={uploadBtnLoading || disabled}
         data-attribute="DragDrop_Default_Button">
          {uploadBtnLoading ? (
            <Spinner  data-attribute="DragDrop_Default_Spinner" />
          ) : (
            <span className='pe-2'>Upload</span>
          )}
        </OutlineButton>
      </div>
      {error && <div className="upload-error-message">{error}</div>}
      {fileError && <div className="upload-error-message">{fileError}</div>}
      {list.length ? (
        <div className="file-list">
          {list.map((file, index) => (
            <div className="file" key={index}>
              <Label title={file.name || (file as any).fileName} data-attribute="DragDrop_Default_Label">
                {file.name || (file as any).fileName}
              </Label>
              <EventHandler onEvent={() => onRemoveExt(index, file.name || (file as any).fileName)} data-attribute={`DragDrop_${((file.name || (file as any).fileName || index)).toString().replace(/[^a-zA-Z0-9]+/g, '_')}_EventHandler`}>
                <img src={close} alt="close" />
              </EventHandler>
            </div>
          ))}
          {filecheckError && <div className="upload-error-message">{filecheckError}</div>}
        </div>
      ) : (
        <div className="no-attachments">No Attachments are uploaded</div>
      )}
    </div>
  );
};

export default DragDrop;
